module.exports = __webpack_public_path__ + "static/img/5.29d6e2f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/3/sp/5.png
// module id = puos
// module chunks = 0